import React from 'react'

const Copy = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M7 12C7 9.172 7 7.757 7.879 6.879C8.757 6 10.172 6 13 6H16C18.828 6 20.243 6 21.121 6.879C22 7.757 22 9.172 22 12V17C22 19.828 22 21.243 21.121 22.121C20.243 23 18.828 23 16 23H13C10.172 23 8.757 23 7.879 22.121C7 21.243 7 19.828 7 17V12Z" stroke="currentColor" strokeWidth="1.625"></path>
<path d="M7 20C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17V11C4 7.229 4 5.343 5.172 4.172C6.344 3.001 8.229 3 12 3H16C16.7956 3 17.5587 3.31607 18.1213 3.87868C18.6839 4.44129 19 5.20435 19 6" opacity="0.5" stroke="currentColor" strokeWidth="1.625"></path>
</svg>
    )
}

export default Copy
